import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#0597A3" d="M16.94 76.1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m60.623 7.503 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM103.57 84.57a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M16.64 48.07h-5.57V42.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H2.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M108.57 19.42c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#0597A3"
      d="M58.12 21.24H29.41a5.74 5.74 0 0 0-5.74 5.74V84.4a5.74 5.74 0 0 0 5.74 5.74h57.42a5.74 5.74 0 0 0 5.74-5.74V27.98c0-3.72-3.02-6.74-6.74-6.74z"
    />
    <path
      fill="#fff"
      d="m40.57 74.908 16.45-9.74-13.7-10.02-4.29 18.62c-.21.89.76 1.6 1.55 1.13z"
    />
    <path
      fill="#00D8D8"
      d="m56.67 36.877 13.7 10.02zl-13.36 18.27 13.7 10.02 13.73-18.77-13.63-10.12z"
    />
    <path
      fill="#001A43"
      d="M79.179 50.147c-.46 0-.92-.14-1.31-.43a2.244 2.244 0 0 1-.51-3.14l14.96-20.72-10.35-7.85a2.247 2.247 0 0 1-.43-3.15c.75-.99 2.16-1.19 3.15-.43l12.1 9.17c.97.74 1.18 2.12.46 3.11l-16.24 22.5c-.44.61-1.13.93-1.83.93z"
    />
    <path
      fill="#001A43"
      d="m57.11 36.278 13.63 10.12 16.57-22.65-13.61-10.15z"
    />
    <path
      fill="#00D8D8"
      d="M91.95 13.188a8.51 8.51 0 0 0-3.38-5.55c-3.78-2.77-9.09-1.94-11.86 1.84l-3.01 4.12 13.61 10.15 3.11-4.25a8.5 8.5 0 0 0 1.54-6.31z"
    />
  </svg>
);
const SvgEnrichedIconEditInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconEditInverted);
export default Memo;
